import { PersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'crypto-hash';

import { isChromatic } from 'utils/chromaticUtils';
import { isStorybook } from 'utils/storybookUtils';

/**
 * Determines whether to enable persisted queries.
 */
export const shouldEnablePersistedQuery = (): boolean => {
  /**
   * Disable persisted queries on cypress test runs until ED-6394 is resolved.
   * Need to look further into solution as previous attempt outweighed cost-benefit with time.
   */
  if (window['Cypress'] || isStorybook() || isChromatic()) {
    return false;
  }

  /**
   * Disable persisted query for storybook and chromatic. Does not play well with MSW.
   */

  return process.env.REACT_APP_APOLLO_PERSISTED_QUERY_ENABLED === 'true';
};

/**
 * Creates a persisted query link if enabled
 */
export const createPersistedQueryLinkIfEnabled = () =>
  shouldEnablePersistedQuery() ? new PersistedQueryLink({ sha256 }) : null;
